import css from 'styled-jsx/css';

export default css.global`
  html,
  body,
  div,
  span,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  pre,
  a,
  small,
  strike,
  strong,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  footer,
  header,
  nav,
  section,
  summary,
  time,
  mark,
  audio {
    @import url('https://cleanhome-web.cleaninglab.co.kr/style/pretendard/dist/web/static/pretendard-dynamic-subset.css');
    font-family: Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, 'Helvetica Neue', 'Segoe UI',
      'Apple SD Gothic Neo', 'Noto Sans KR', 'Malgun Gothic', sans-serif !important;
  }

  html,
  body,
  div,
  span,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  pre,
  a,
  small,
  strike,
  strong,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  footer,
  header,
  nav,
  section,
  summary,
  time,
  mark,
  audio {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: inherit;
    font-weight: bolder;
    color: inherit;
    margin: 0;
  }

  body {
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  div {
    outline: none;
  }

  .main .slick-dots li {
    margin: 0;
    width: 12px;
  }

  .main .slick-dots li.slick-active button:before {
    color: #868e96;
  }

  .main .slick-dots li button:before {
    color: rgba(0, 0, 0, 0.3);
    font-size: 8px;
  }

  .main .slick-dots {
    bottom: -2.5rem;
  }

  a {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .location-slider > .slide:not(:first-child) {
    display: none;
  }
  .location-slider > .slide:first-child {
    padding: 0 20px;
  }

  .manager_slider .slick-dots {
    bottom: -10px;
  }

  .manager_slider .slick_sliders {
    height: 100%;
  }

  .manager_slider .slick-list {
    height: 400px;
  }

  @supports not (-webkit-touch-callout: none) {
    /* CSS for other than iOS devices */
  }

  /** pc **/

  .slick-prev {
    left: -80px !important;
    z-index: 1;
  }
  .slick-next {
    right: -80px !important;
    z-index: 1;
  }

  @media screen and (min-width: 1024px) {
    body .slick-dots li {
      display: none;
    }
  }

  body img {
    image-rendering: auto !important;
  }

  body .rs-modal-content {
    border-radius: 8px;
  }

  body .rs-modal-wrapper {
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  body .rs-modal-sm {
    width: auto;
  }

  /** 아코디언 **/

  .accordion {
    -webkit-box-shadow: 0px 13px 23px -13px rgba(0, 0, 0, 0.5);
    width: 420px;
    background-color: transparent;
    margin: auto;
    margin-top: 50px;
  }

  .title {
    height: auto;
    background-color: white;
    color: rgba(0, 0, 0, 0.85);
    text-transform: uppercase;
    letter-spacing: 1px;
    text-align: left;
    line-height: 2;
    font-size: 17px;
    font-weight: 600;
    position: relative;
    padding-top: 16px;
    padding-bottom: 12px;
    z-index: 2000;
    margin-top: 2px;
    transition: all 0.2s ease-in;
    border-top: #f1f3f5 1px solid;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .title-open {
    color: #227886;
  }

  .title:hover {
    cursor: pointer;
    background-color: white;
  }

  .title:active {
    color: #227886;
    background-color: white;
  }

  .content {
    height: 30px;
    background-color: white;
    border-radius: 4px;
    color: rgba(0, 0, 0, 0.4);
    font-size: 16px;
    text-align: center;
    font-weight: 400;
    position: relative;
    z-index: 1000;
    margin-top: -30px;
    text-align: left;
    line-height: 140%;
    transition: 200ms cubic-bezier(0.6, -0.28, 0.735, 0.045);
  }

  .content-open {
    margin-top: 0px;
    height: auto;
    background-color: white;
    transition: 350ms cubic-bezier(0.08, 1.09, 0.32, 1.275);
  }

  .content-text {
    padding: 0 0 1rem 0;
    visibility: hidden;
    opacity: 0;
    overflow: auto;
  }

  .content-text-open {
    visibility: visible;
    opacity: 1;
  }

  .fa-angle-down {
    font-size: 20px;
  }

  .plus-sign {
    display: block;
    font-size: 4.7vw;
    transition: all 0.2s;
  }

  .rotate-180 {
    transform: rotate(180deg);
    transition: all 0.5s;
  }

  .icon-wrapper img {
    width: 50%;
  }

  .accordion-wrapper {
    /*display: flex;*/
  }

  * {
    font-family: Pretendard, Apple SD Gothic Neo, Apple Sandoll Gothic Neo, -apple-system, BlinkMacSystemFont, system-ui,
      Roboto, 'Helvetica Neue', 'Segoe UI', 'Noto Sans KR', 'Malgun Gothic', sans-serif !important;
  }
`;
